'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoGlobe = function GoGlobe(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c-8.3 0-15 6.7-15 15s6.7 15 15 15c1 0 2-0.1 3-0.3-0.4-0.2-0.5-1.6-0.1-2.4 0.4-0.8 1.8-3.1 0.5-3.8s-1-1.1-1.8-2-0.5-0.9-0.5-1.2c-0.2-0.7 0.7-1.9 0.8-2s0-0.5 0-0.7-0.6-0.5-0.7-0.5-0.3 0.3-0.5 0.3-1.1-0.6-1.2-0.7-0.3-0.5-0.6-0.8-0.3 0-0.7-0.2-1.7-0.6-2.7-1.1-1.1-0.9-1.1-1.3-0.7-1-0.9-1.5c-0.3-0.4-0.4-1-0.5-0.8s0.6 1.6 0.5 1.7-0.4-0.5-0.7-0.8 0.3-0.2-0.6-2.1 0.3-2.7 0.4-3.7 0.7 0.3 0.4-0.3 0-1.9-0.3-2.3-2 0.5-2 0.5c0.1-0.5 1.5-1.2 2.5-2s1.7-0.1 2.5 0.1 0.9 0.2 0.6-0.1 0.1-0.3 0.8-0.2 0.8 0.8 1.8 0.8 0.1 0.2 0.2 0.4-0.1 0.2-0.8 0.7 0 0.4 1.2 1.2 0.8-0.5 0.6-1.1 0.9-0.2 0.9-0.2c0.7 0.5 0.6 0.1 1.1 0.2s1.9 1.4 1.9 1.4c-1.8 0.9-0.7 1-0.4 1.2s-0.6 0.7-0.6 0.7c-0.3-0.4-0.4 0-0.6 0.1s-0.1 0.5-0.1 0.5c-1.2 0.2-0.9 1.5-0.9 1.8s-0.8 0.7-1 1.2 0.6 1.4 0.2 1.4-0.8-1.4-2.8-0.9c-0.6 0.2-2 0.9-1.3 2.4s2-0.4 2.4-0.2-0.1 1.1-0.1 1.1 1.2 0.1 1.3 1.3 1.6 1.1 1.9 1.2 1.5-0.9 1.6-1 0.9-0.6 2.3 0.2 2.1 0.7 2.6 1.1 0.1 1 0.6 1.2 2.2-0.1 2.7 0.7-1.9 4.5-2.6 4.9-1.1 1.3-1.8 1.9-1.8 1.4-2.7 1.9c-0.9 0.5-1.1 1.5-1.4 1.7 6.7-1.5 11.7-7.4 11.7-14.6 0-8.3-6.7-15-15-15z m3.5 14.1c-0.2 0-0.6 0.4-1.7-0.2s-1.7-0.5-1.8-0.6c0 0-0.1-0.2 0.4-0.3 0.9-0.1 2.1 0.9 2.3 0.9s0.4-0.3 0.9-0.1c0.5 0.1 0.1 0.2-0.1 0.3z m-4.9-12.6c-0.1-0.1 0.1-0.2 0.2-0.3 0.1-0.1 0-0.2 0.1-0.3 0.2-0.2 1.3-0.5 1.1 0.1s-1.2 0.6-1.4 0.5z m2.6 1.9c-0.3 0-1.2-0.1-1-0.3 0.6-0.6-0.3-0.8-0.8-0.8s-0.7-0.3-0.5-0.4 1.3 0 1.5 0.2 1.1 0.5 1.2 0.8 0 0.5-0.4 0.5z m3.2-0.1c-0.3 0.2-1.8-0.8-2-1.1-1.3-1-1.9-0.7-2.2-0.9s-0.2-0.4 0.2-0.7 1.5 0.1 2.2 0.2 1.4 0.5 1.4 1.1c0 0.6 0.7 1.2 0.4 1.4z' })
        )
    );
};

exports.default = GoGlobe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/globe.js
// module id = 1908
// module chunks = 0